import { memo, type ReactNode } from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { patientFinderFilterCardSx } from "./patientFinderToggleStyles";

export interface CommunicationsPatientFinderFilterCardProps {
  title: string;
  /** Ex.: true para exibir “(opcional)” ao lado do título. */
  showOptionalLabel?: boolean;
  helperText?: string;
  children: ReactNode;
}

/**
 * Card visual consistente para blocos de filtro do modal Encontrar / filtrar pacientes.
 */
const CommunicationsPatientFinderFilterCard = memo(
  ({
    title,
    showOptionalLabel = false,
    helperText,
    children,
  }: CommunicationsPatientFinderFilterCardProps) => {
    return (
      <Paper variant="outlined" sx={patientFinderFilterCardSx}>
        <Stack spacing={1.5} alignItems="flex-start" sx={{ width: "100%" }}>
          <Stack spacing={0.25} sx={{ width: "100%" }}>
            <Typography variant="subtitle2" fontWeight={700}>
              {title}
              {showOptionalLabel ? (
                <>
                  {" "}
                  <Typography
                    component="span"
                    variant="caption"
                    color="text.secondary"
                  >
                    (opcional)
                  </Typography>
                </>
              ) : null}
            </Typography>
            {helperText ? (
              <Typography variant="caption" color="text.secondary">
                {helperText}
              </Typography>
            ) : null}
          </Stack>
          {children}
        </Stack>
      </Paper>
    );
  },
);

CommunicationsPatientFinderFilterCard.displayName =
  "CommunicationsPatientFinderFilterCard";

export default CommunicationsPatientFinderFilterCard;
